import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { parseMessages } from 'helpers/parse-dll-error'
import { prepareData } from 'helpers/prepare-req-data'
import client from 'api'
import _ from 'lodash'


const initialState = {
    startIx202001Status: 'idle',
    startIx202001Error: undefined as any,
    loadUserParamsIx202001Status: 'idle',
    loadUserParamsIx202001Error: undefined as any,
    loadUserParamsIx202001LastParams: undefined,

    ix202001List: [] as any[],
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

}
export const startIx202001 = createAsyncThunk('ix202001/startIx202001', async (ix202001: any, { rejectWithValue }: any) => {

    const url = `/api/ixweb/StartIx202001/`

    const res = await client.post(url, prepareData(ix202001))

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { ...ix202001, HDR_ID: res.data.data.id }
        }
    } else {  // backend response
        return res.data
    }
})
export const loadUserParamsIx202001 = createAsyncThunk('ix202001/loadUserParamsIx202001', async ({ forceReload=false }: any, { rejectWithValue, getState }: any) => {
    const { loadUserParamsIx202001LastParams } = getState().Ix202001

    const url = `/api/ixweb/LoadUserParamsIx202001/`
    let _allParams: any = new URLSearchParams(url.split('?')[1])
    _allParams.sort()
    _allParams = _allParams.toString()

    if (_allParams === loadUserParamsIx202001LastParams && !forceReload) {
        return
    }

    const res = await client.get(url)

    // check type of response -  winrest or backend
    if (typeof(res.data) === 'object' && res.data.hasOwnProperty('status')) {  // winrest response
        if (res.data.status === 'Failed') {
            return rejectWithValue(parseMessages(res.data.messages))
        } else {
            return { data: res.data.data, params: _allParams }
        }
    } else {  // backend response
        return { data: res.data, params: _allParams }
    }
})

const Ix202001Slice = createSlice({
    name: 'ix202001',
    initialState,
    reducers: {
        resetstartIx202001Error: (state) => {
            state.startIx202001Error = undefined
        },
        resetloadUserParamsIx202001Error: (state) => {
            state.loadUserParamsIx202001Error = undefined
        },
        removeFromIx202001ListById: (state, action) => {
            state.ix202001List = state.ix202001List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
    },
    extraReducers: builder => {
        builder.addCase(startIx202001.pending, (state) => {
            state.startIx202001Status = 'pending'
            state.startIx202001Error = undefined
        })
        builder.addCase(startIx202001.fulfilled, (state, action) => {
            state.startIx202001Status = 'idle'


            state.ix202001List = [...state.ix202001List, action.payload]
        })
        builder.addCase(startIx202001.rejected, (state, action) => {
            state.startIx202001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startIx202001Error = action.error.message
            } else {
                state.startIx202001Error = action.payload
            }
        })

        builder.addCase(loadUserParamsIx202001.pending, (state) => {
            state.loadUserParamsIx202001Status = 'pending'
            state.loadUserParamsIx202001Error = undefined
        })
        builder.addCase(loadUserParamsIx202001.fulfilled, (state, action) => {
            state.loadUserParamsIx202001Status = 'idle'

            if (!action.payload) { return }

            state.loadUserParamsIx202001LastParams = action.payload.params

            state.ix202001List = action.payload.data
        })
        builder.addCase(loadUserParamsIx202001.rejected, (state, action) => {
            state.loadUserParamsIx202001Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsIx202001Error = action.error.message
            } else {
                state.loadUserParamsIx202001Error = action.payload
            }
        })

    }
})

export const {
    resetstartIx202001Error,
    resetloadUserParamsIx202001Error,
    removeFromIx202001ListById,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
} = Ix202001Slice.actions
export default Ix202001Slice.reducer
